/* eslint-disable react/no-danger */
import * as React from "react";
import { useTranslation } from "react-i18next";
import SharedComponents, { Avatar } from "@audacia-hq/shared/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";

import { MemberAlert } from "../../models/member";
import { ExpertIdentifier } from "../../models/expert";

import MemberAlertCard from "./MemberAlertCard";

interface Props {
  alert: MemberAlert,
  onClose: () => void;
  expertIdentifier: ExpertIdentifier;
}

const MemberAlertModal: React.FC<Props> = ({
  alert, onClose, expertIdentifier,
}) => {
  const { t } = useTranslation("member");

  return (
    <>
      {expertIdentifier && (
        <SharedComponents.Modal
          mobileFullscreen
          show
          onClose={onClose}
          title={(
            <div className="flex gap-3 md:gap-6 font-normal">
              <Avatar
                name={expertIdentifier.pseudo}
                uid={expertIdentifier.expertUid}
                src={expertIdentifier.picture}
                loading="lazy"
                height={100}
                width={100}
                className="rounded-lg"
              />
              <div className="flex flex-col gap-3">
                <div className="text-lg sm:text-xl font-semibold">
                  {t("alert.modalTitle")}
                  {" "}
                  <SharedComponents.Tooltip
                    groupClassName="inline"
                    className="w-64 z-10"
                    arrow
                    position="bottom"
                    message={(
                      <>
                        <div className="font-semibold py-2 text-center">{t("alert.howTo.title")}</div>
                        <ul className="list-disc p-2 pl-6 flex flex-col gap-6">
                          <li dangerouslySetInnerHTML={{ __html: t("alert.howTo.text1") }} />
                          <li dangerouslySetInnerHTML={{ __html: t("alert.howTo.text2") }} />
                        </ul>
                      </>
                    )}
                  >
                    <FontAwesomeIcon icon={faQuestionCircle} />
                  </SharedComponents.Tooltip>

                </div>
                <div className="flex flex-wrap gap-x-3 items-center text-sm sm:text-base">
                  <span className="font-semibold text-sm">
                    <span>{expertIdentifier.pseudo}</span>
                  </span>
                  <SharedComponents.Tooltip
                    position="bottom"
                    className="w-48"
                    arrow
                    message={t("common:accessCodeTips")}
                  >
                    <span className="border border-slate-100 bg-slate-50 hover:bg-slate-100 text-gray-800 text-sm font-medium px-1 py-0.5 rounded">{String(expertIdentifier.expertCode).padStart(3, "0")}</span>
                  </SharedComponents.Tooltip>
                </div>
              </div>
            </div>
          )}
        >
          <MemberAlertCard alert={alert} expertIdentifier={expertIdentifier} manualSubmit cancelAction={onClose} />
        </SharedComponents.Modal>
      )}
    </>
  );
};

export default MemberAlertModal;
